import { render, staticRenderFns } from "./OnboardingSeekingSelector.vue?vue&type=template&id=6e2520d0&scoped=true&"
import script from "./OnboardingSeekingSelector.vue?vue&type=script&lang=js&"
export * from "./OnboardingSeekingSelector.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingSeekingSelector.vue?vue&type=style&index=0&id=6e2520d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2520d0",
  null
  
)

export default component.exports